import { Fragment } from "react";
import CommonHeader from "../../components/common/commonHeader/CommonHeader";
import MainFeaturedPost from "../../components/ProfileComponents/MainFeaturedPost";
import { Box, Container, Grid } from "@mui/material";

import StudentDetails from "../../components/ProfileComponents/StudentDetails";
import ContactDetails from "../../components/ProfileComponents/ContactDetails";
import PaymentDetails from "../../components/ProfileComponents/PaymentDetails";

const mainFeaturedPost = {
  title: "Student Profile ",
  description:
    "“Education is the passport to the future, for tomorrow belongs to those who prepare for it today.”",
  image: "https://source.unsplash.com/random/?blog/",
  imageText: "main image description",
  linkText: "Malcolm X",
};


export const ProfilePage = () => {
  const user =  JSON.parse(sessionStorage.getItem("user"));
  return (
    <Fragment>
      <CommonHeader />
      <Box sx={{ width:"100%",height:"80px" }}>
      </Box>
      <Container maxWidth="lg">
        <MainFeaturedPost post={mainFeaturedPost} />
        <Grid container spacing={4}>
          <StudentDetails user={user} />
          <ContactDetails user={user} />
          <PaymentDetails user={user} />
        </Grid>
      </Container>
    </Fragment>
  );
};
